export const SUBSCRIPTION_LABEL_STATE = {
  FREE: 'free',
  YOURS: 'yours',
  UPGRADE: 'upgrade',
}

export const SUBSCRIPTION_LABEL_TIER = {
  ESSENTIALS: 'essentials',
  PREMIUM: 'premium',
}
